<template lang="html">
  <div class="c-timeline" :class="displayClass">
    <div class="c-timeline__progress" :style="scaleX"></div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  props: {
    progress: {
      type: Number
    },
    display: {
      type: Boolean
    }
  },
  computed: {
    ...mapGetters([
      'timer',
      'timerMax'
    ]),
    scaleX () {
      return 'transform : scaleX(' + this.timer / this.timerMax + ')'
    },
    displayClass () {
      return {
        's--hide': this.display === false
      }
    }
  }
}
</script>

<style lang="scss">
@import "../../vars";

.c-timeline {
  position: absolute;
  z-index: 35;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: rgba($white, .1);
  transition: all ease .55s;

  &.s--hide {
    opacity: 0;
    transition: all ease .25s;
  }

  &__progress {
    position: absolute;
    z-index: 36;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 4px;
    background: $white;
    transform: scaleX(0.2);
    transform-origin: left;
    // transition: transform linear .01s;
  }
}
</style>



// WEBPACK FOOTER //
// Timeline.vue?77e7e1e8